import dayjs from "dayjs";
import Link from "next/link";
import React from "react";

const Footer = () => {
  const currentYear = dayjs().year();

  <p className="text-xs">© {currentYear} Landit Inc.</p>;
  return (
    <footer className="flex h-[50px] w-full flex-shrink-0 items-center justify-between bg-[#EBECED] px-8 text-[#706D65]">
      <div className="flex gap-6">
        <Link
          className="flex gap-2 text-xs"
          href="https://landit-inc.notion.site/40654e50002a49cb933b276b5eecaf4b?pvs=4"
          target="_blank"
        >
          利用規約
          <img src="/svg/TermOfUse.svg" alt="Term of use" width={"12px"} />
        </Link>
        <Link className="flex gap-2 text-xs" href="https://landit.co.jp/privacypolicy" target="_blank">
          プライバシーポリシー
          <img src="/svg/TermOfUse.svg" alt="Term of use" width={"12px"} />
        </Link>
      </div>
      <p className="text-xs">© {currentYear} Landit Inc.</p>
    </footer>
  );
};

export default Footer;
